import React, { useState } from 'react';
import UploadForm from './UploadForm';
import SearchPhotos from './SearchPhotos';
import './App.css';

const App = () => {
    const [activeTab, setActiveTab] = useState('search'); // Domyślnie ustawione na 'search'

    return (
        <div className="gradient-background" style={{ width: '100%', height: '100vh' }}>
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <h1>Leistungsnachweisen</h1>

                {/* Menu nawigacyjne */}
                <div style={{ marginBottom: '20px' }}>
                    <button
                        onClick={() => setActiveTab('search')}
                        style={{
                            padding: '10px 20px',
                            marginRight: '10px',
                            backgroundColor: activeTab === 'search' ? '#007bff' : '#ccc',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                        }}
                    >
                        Vorschau
                    </button>

                    <button
                        onClick={() => setActiveTab('upload')}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: activeTab === 'upload' ? '#007bff' : '#ccc',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                        }}
                    >
                        Hinzufügen
                    </button>
                </div>

                {/* Wyświetlanie odpowiedniego komponentu w zależności od aktywnej zakładki */}
                {activeTab === 'search' && <SearchPhotos />}
                {activeTab === 'upload' && <UploadForm />}
            </div>
        </div>
    );
};

export default App;
